import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ProductionReviewInterface from '@/components/ProductionReviewInterface';
import { SafeErrorBoundary } from '@/components/SafeErrorBoundary';
import { useBillQueue } from '@/hooks/useBillQueue';

const ProductionReview: React.FC = () => {
  const { queueItemId } = useParams<{ queueItemId: string }>();
  const { queueItems, updateQueueItem } = useBillQueue();

  if (!queueItemId) {
    return <Navigate to="/dashboard/bill-queue" replace />;
  }

  // Find the queue item
  const queueItem = queueItems.find(item => item.id === queueItemId);

  if (!queueItem) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
          <p className="mt-4 text-muted-foreground">Loading queue item...</p>
        </div>
      </div>
    );
  }

  const handleUpdate = async (data: any) => {
    try {
      await updateQueueItem({
        id: queueItem.id,
        data: {
          extracted_data: data,
          processing_status: 'review_required',
          notes: data.notes,
          assigned_to_account_id: data.customer_id || null,
          amount: data.total_amount ? parseFloat(data.total_amount) : null
        }
      });
    } catch (error) {
      console.error('Failed to update queue item:', error);
      throw error;
    }
  };

  const handleClose = () => {
    // Navigate back to the queue
    window.location.href = '/dashboard/bill-queue';
  };

  return (
    <SafeErrorBoundary level="page">
      <ProductionReviewInterface 
        queueItem={queueItem}
        onUpdate={handleUpdate}
        onClose={handleClose}
      />
    </SafeErrorBoundary>
  );
};

export default ProductionReview;